import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import locationGroupActions from 'actions/locationGroups'
import locationActions from 'actions/locations'
import userActions from 'actions/users'
import userGroupActions from 'actions/userGroups'
import Component from 'components/CycleCounts/ListView/Filter'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

const mapDispatchToProps = (dispatch, props) => ({
  getLocationGroups: (params) => dispatch(locationGroupActions.getOptions(params)),
  getLocations: (params) =>
    dispatch(locationActions.getOptions({ locationVendingTypes: ['NonVending'], ...params })),
  getUsers: (params) => dispatch(userActions.getOptions({ active: 'Active', ...params })),
  getUserGroups: (params) => dispatch(userGroupActions.getOptions(params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
